import { CelebrationsCustomPageTemplate } from "./template";
import { useCelebrationsCustomPage } from "./logic";

export const CelebrationsCustomPage = () : JSX.Element => {
    const props = useCelebrationsCustomPage();

    return (
        <CelebrationsCustomPageTemplate {...props}/>
    )
}